module.exports = __webpack_public_path__ + "static/media/terms_March2023.858df92f.pdf";